export default class SQLConnectionConfig {
    public name = ''
    public server = ''
    public port = 0
    public user = ''
}
